/**
 * Built-in layer color palette: 10 base swatches + 3 rainbow extras.
 * Custom user swatches are persisted to localStorage so they outlive a refresh.
 */

const STORAGE_KEY = 'promo-studio:custom-swatches';

export const BASE_PALETTE = [
  '#4ea8ff', // blue
  '#ff5a5f', // red
  '#57d18a', // green
  '#ffd34e', // yellow
  '#a78bfa', // purple
  '#f97316', // orange
  '#06b6d4', // cyan
  '#ec4899', // pink
  '#94a3b8', // slate
  '#1f2937', // ink
] as const;

export const RAINBOW_EXTRA = [
  '#ff0000',
  '#7f00ff',
  '#00ff88',
] as const;

export const FULL_PALETTE: readonly string[] = [...BASE_PALETTE, ...RAINBOW_EXTRA];

export function getCustomSwatches(): string[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((x): x is string => typeof x === 'string');
  } catch {
    return [];
  }
}

export function addCustomSwatch(color: string): void {
  const existing = getCustomSwatches();
  if (existing.includes(color)) return;
  const next = [...existing, color].slice(-32);
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    // ignore quota
  }
}

export function removeCustomSwatch(color: string): void {
  const next = getCustomSwatches().filter((c) => c !== color);
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    // ignore
  }
}
